export default "__VITE_ASSET__bd0CwjH9__"